import React, { useState, useCallback, MouseEvent } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DeleteComplemento from './options/DeleteComplemento';
import EditComplemento from './options/EditComplemento';

import {
  AccordionTitleWrapper,
  AccordionActionsWrapper,
} from '../../../../drawer_styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '48px',
    },
  }),
);

interface SummaryProps {
  title: string;
  isObrigatorio: boolean;
  index: number;
}

const ITEM_HEIGHT = 48;

const Summary: React.FC<SummaryProps> = ({ title, isObrigatorio, index }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        className={classes.root}
      >
        <Grid container justify="space-between" alignItems="center">
          <Grid item lg={3} md={3} xs={4}>
            <AccordionTitleWrapper>
              <h4>{title}</h4>
            </AccordionTitleWrapper>
          </Grid>

          <Grid item lg={3} md={3} xs={4}>
            <AccordionActionsWrapper>
              <span>{isObrigatorio ? 'Obrigatório' : 'Opcional'}</span>

              <div
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
              >
                <IconButton
                  aria-label="more"
                  aria-controls="options-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="options-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: '20ch',
                    },
                  }}
                >
                  <MenuItem onClick={handleClose}>
                    <EditComplemento index={index} title={title} />
                  </MenuItem>

                  <MenuItem onClick={handleClose}>
                    <DeleteComplemento
                      index={index}
                      title_complemento={title}
                    />
                  </MenuItem>
                </Menu>
              </div>
            </AccordionActionsWrapper>
          </Grid>
        </Grid>
      </AccordionSummary>
    </>
  );
};

export default Summary;
